import { useState } from 'react'
import reactLogo from './assets/react.svg'
import viteLogo from '/vite.svg'
import './App.css'
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import OverviewUCTC from './pages/OverviewUCTC';
import VCMessage from './pages/VCMessage';
import ProVCMessage from './pages/ProVcMessage';
import TreasurerMessage from './pages/TreasurerMessage';
import AdvisorMessage from './pages/AdvisorMessage';
import FounderMessage from './pages/FounderMessage';
import ChairmanMessage from './pages/ChairmanMessage';
import RegistrarMessage from './pages/RegistrarMessage';
import ExecutiveLeaders from './pages/ExecutiveLeaders';
import MouMoa from './pages/MouMoa';
import FaqPage from './pages/FaqPage';
import Admission from "./pages/administration/Admission";
import Accounts from "./pages/administration/Accounts";
import Sad from "./pages/administration/Sad";
import Cad from "./pages/administration/Cad";
import Itd from "./pages/administration/Itd";
import Lid from "./pages/administration/Lid";
import Chancellor from "./pages/administration/Chancellor";
import Vc from "./pages/administration/Vc";
import Provc from "./pages/administration/Provc";
import Treasurer from "./pages/administration/Treasurer";
import Registrar from "./pages/administration/Registrar";
import Syndicate from "./pages/administration/Syndicate";
import AcademicCouncil from "./pages/administration/AcademicCouncil";
import Deans from "./pages/administration/Deans";
import Proctors from "./pages/administration/Proctors";
import Coe from "./pages/administration/Coe";
import Cse from "./pages/program/Cse";
import Bba from "./pages/program/Bba";
import Civil from "./pages/program/Civil";
import Mechanical from "./pages/program/Mechanical";
import English from "./pages/program/English";
import Eee from "./pages/program/Eee";
import Bis from "./pages/program/Bis";
import Mba from "./pages/program/Mba";
import Mph from "./pages/program/Mph";
import Mis from "./pages/program/Mis";
import Htm from "./pages/program/Htm";
import Bte from "./pages/program/Bte";
import AdmissionRequirement from './pages/AdmissionRequirement';
import AdmissionTest from './pages/AdmissionTest';
import DocumentsRequired from './pages/DocumentsRequired';
import Scholarships from './pages/Scholarships';
import WhyStudy from './pages/WhyStudy';
import FeeStructure from './pages/FeeStructure';
import Business from './pages/faculty/Business';
import Science from './pages/faculty/Science';
import Humanities from './pages/faculty/Humanities';
import NoticeDetails from './pages/NoticeDetails';
import NewsDetails from './pages/NewsDetails';
import AllNotice from './pages/AllNotice';
import NewsList from './pages/NewsList';
import CareerPage from './pages/CareerPage';
import CareerDetails from './pages/CareerDetails';
import AcademicCalendar from './pages/AcademicCalendar';
import AdmissionAdvertisement from './pages/AdmissionAdvertisement';
import AcademicPolicy from './pages/AcademicPolicy';
import AcademicSystem from './pages/AcademicSystem';
import AdmissionForm from './pages/AdmissionForm';
import AdmitCard from './pages/AdmitCard';
import OfferLetter from './pages/OfferLetter';
import CertificateVerification from './pages/CertificateVerification';
import AllEvents from './pages/AllEvents';
import EventsDetails from './pages/EventsDetails';
import AllFaculty from './pages/AllFaculty';
import FacultyProfile from './pages/FacultyProfile';
import VideoPage from './pages/VideoPage';
import AlumniPage from './pages/AlumniPage';
import Gallery from './pages/Gallery';
import IqacPage from './pages/IqacPage';
import NotFound from './pages/NotFound';
import ApplyOnline from './pages/ApplyOnline';
import DepartmentCSE from './pages/departments/DepartmentCSE';
import DBusiness from './pages/departments/Business';
import DepartmentCE from './pages/departments/DepartmentCE';
import DepartmentME from './pages/departments/DepartmentME';
import DepartmentEEE from './pages/departments/DepartmentEEE';
import DepartmentELL from './pages/departments/DepartmentELL';
import DepartmentDIS from './pages/departments/DepartmentDIS';
import DepartmentDPH from './pages/departments/DepartmentDPH';
import TermsPrivacy from './pages/TermsPrivacy';
import DepartmentHTM from './pages/departments/DepartmentHTM';
import AntiSexual from './pages/AntiSexual';
import StudentPayment from './pages/StudentPayment';
import PaymentConfirmation from './pages/PaymentConfirmation';
import DepartmentDTE from './pages/departments/DepartmentDTE';
import ApplicationSuccess from "./pages/ApplicationSuccess";

function App() {
  const [count, setCount] = useState(0)

  return (
    <Router>
		<Routes>
			<Route path="/" element={<MainLayout />}>
				<Route index element={<HomePage />} />
				<Route path="/about" element={<AboutPage />} />
				<Route path="/contact" element={<ContactPage />} />
				<Route path="/overview" element={<OverviewUCTC />} />
				<Route path="/vc-message" element={<VCMessage />} />
				<Route path="/provc-message" element={<ProVCMessage />} />
				<Route path="/treasurer-message" element={<TreasurerMessage />} />
				<Route path="/advisor-message" element={<AdvisorMessage />} />
				<Route path="/chairman-message" element={<ChairmanMessage />} />
				<Route path="/founder-message" element={<FounderMessage />} />
				<Route path="/registrar-message" element={<RegistrarMessage />} />
				<Route path="/executive-leader" element={<ExecutiveLeaders />} />
				<Route path="/mou-moa" element={<MouMoa />} />
				<Route path="/faq" element={<FaqPage />} />
				<Route path="administration">
					<Route path="admission" element={<Admission />} />
					<Route path="accounts" element={<Accounts />} />
					<Route path="sad" element={<Sad />} />
					<Route path="cad" element={<Cad />} />
					<Route path="itd" element={<Itd />} />
					<Route path="lid" element={<Lid />} />
					<Route path="chancellor" element={<Chancellor />} />
					<Route path="vc" element={<Vc />} />
					<Route path="pro-vc" element={<Provc />} />
					<Route path="treasurer" element={<Treasurer />} />
					<Route path="registrar" element={<Registrar />} />
					<Route path="syndicate" element={<Syndicate />} />
					<Route path="academic-council" element={<AcademicCouncil />} />
					<Route path="deans" element={<Deans />} />
					<Route path="proctors" element={<Proctors />} />
					<Route path="coe" element={<Coe />} />
				</Route>
				<Route path="programs">
					<Route path="cse" element={<Cse />} />
					<Route path="bba" element={<Bba />} />
					<Route path="civil" element={<Civil />} />
					<Route path="mechanical" element={<Mechanical />} />
					<Route path="english" element={<English />} />
					<Route path="eee" element={<Eee />} />
					<Route path="bis" element={<Bis />} />
					<Route path="mba" element={<Mba />} />
					<Route path="mph" element={<Mph />} />
					<Route path="mis" element={<Mis />} />	
					<Route path="htm" element={<Htm />} />
					<Route path="bte" element={<Bte />} />
				</Route>
				<Route path="/admission-requirement" element={<AdmissionRequirement />} />
				<Route path="/admission-test" element={<AdmissionTest />} />
				<Route path="/admission-documents" element={<DocumentsRequired />} />
				<Route path="/scholarship" element={<Scholarships />} />
				<Route path="/why-us" element={<WhyStudy />} />
				<Route path="/fees" element={<FeeStructure />} />
				<Route path="faculties">
					<Route path="business" element={<Business />} />
					<Route path="science" element={<Science />} />
					<Route path="humanities" element={<Humanities />} />
				</Route>
				<Route path="/notice/:id" element={<NoticeDetails />} />
				<Route path="/news/:id" element={<NewsDetails />} />
				<Route path="/all-notice" element={<AllNotice />} />
				<Route path="/all-news" element={<NewsList />} />
				<Route path="/career" element={<CareerPage />} />
				<Route path="/academic-calendar" element={<AcademicCalendar />} />
				<Route path="/admission-advertisement" element={<AdmissionAdvertisement />} />
				<Route path="/academic-policy" element={<AcademicPolicy />} />
				<Route path="/academic-system" element={<AcademicSystem />} />
				<Route path="/admission-form" element={<AdmissionForm />} />
				<Route path="/admit-card" element={<AdmitCard />} />
				<Route path="/offer-letter" element={<OfferLetter />} />
				<Route path="/certificate-verification" element={<CertificateVerification />} />
				<Route path="/all-events" element={<AllEvents />} />
				<Route path="/events/:id" element={<EventsDetails />} />
				<Route path="/faculty" element={<AllFaculty />} />
				<Route path="/profile/:id" element={<FacultyProfile />} />
				<Route path="/videos" element={<VideoPage />} />
				<Route path="/alumni" element={<AlumniPage />} />
				<Route path="/gallery" element={<Gallery />} />
				<Route path="/iqac" element={<IqacPage />} />
				<Route path="/career-details/:id" element={<CareerDetails />} />
				<Route path="/apply-online" element={<ApplyOnline />} />
				<Route path="/application-success" element={<ApplicationSuccess />} />
				<Route path="department">
					<Route path="cse" element={<DepartmentCSE />} />
					<Route path="business" element={<DBusiness />} />
					<Route path="ce" element={<DepartmentCE />} />
					<Route path="me" element={<DepartmentME />} />
					<Route path="eee" element={<DepartmentEEE />} />
					<Route path="ell" element={<DepartmentELL />} />
					<Route path="dis" element={<DepartmentDIS />} />
					<Route path="dph" element={<DepartmentDPH />} />
					<Route path="htm" element={<DepartmentHTM />} />
					<Route path="dte" element={<DepartmentDTE />} />
				</Route>
				<Route path="/terms" element={<TermsPrivacy />} />
				<Route path="/payment-online" element={<StudentPayment />} />
				<Route path="/payment-confirmation" element={<PaymentConfirmation />} />
				<Route path="committee">
					<Route path="sexual-harassment" element={<AntiSexual />} />
				</Route>
				<Route path="*" element={<NotFound />} />
			</Route>
		</Routes>
	</Router>
  )
}

export default App
